import {
  put,
  call,
  takeLatest,
  delay,
  select,
  takeEvery,
} from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import {
  getCategories,
  getSingleCategory,
  addCategory,
  deleteCategory,
  add_new_attribute_bool,
  add_new_attribute_num,
  add_new_attribute_text,
  edit_attribute,
  editCategory,
  append_attribute_values,
  create_progress_monitor,
  get_progress_monitor,
  hideCategory,
  unhideCategory,
} from "./services";

function* __CATEGORIES(action) {
  try {
    var payload = {
      categories: [],
    };
    const res = yield getCategories();
    const data = res?.data;
    payload.categories = data?.resource?.sub_categories;
    yield put(actions.allCategoriesSuccess(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.allCategoriesFailure({ error: errorMessage }));
  }
}
function* __SINGLECATEGORY(action) {
  try {
    const res = yield getSingleCategory(action.payload.data?.category_id);
    const data = res?.data;
    action.payload.success(data?.resource);
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.failure(errorMessage);
  }
}

function* __addNewAttribute(action) {
  try {
    let res;
    if (action.payload.data.type === 3)
      res = yield add_new_attribute_bool(action.payload.data);
    if (action.payload.data.type === 1) {
      res = yield add_new_attribute_num(action.payload.data);
    }
    if (action.payload.data.type === 2) {
      res = yield add_new_attribute_text(action.payload.data);
    }
    if (res) {
      action.payload.success(res.data);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __editAttribute(action) {
  try {
    let res;
    let data = action.payload.data;
    yield put(actions.get_progress_monitor(data.progress_monitoring_record_id));
    res = yield edit_attribute(data);
    if (res) {
      if (data.type === 2) {
        const attribute = yield append_attribute_values(data);
        action.payload.success(attribute.data);
      } else {
        action.payload.success(res.data);
      }
      yield put(actions.allCategories());
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __appendAttributeValues(action) {
  try {
    let res;
    let data = action.payload.data;

    res = yield append_attribute_values(data);
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __addCategory(action) {
  try {
    const res = yield addCategory(action.payload.data);
    const data = res?.data;
    yield put(actions.allCategories());
    action.payload.success(data);
    yield put(actions.addCategorySuccess(data));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
    yield put(actions.addCategoryFailure({ error: errorMessage }));
  }
}

function* __editCategory(action) {
  try {
    let payload = action.payload.data;
    const res = yield editCategory(payload);

    const data = res?.data;
    yield put(actions.allCategories());
    action.payload.success(data);
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __deleteCategory(action) {
  try {
    const res = yield deleteCategory(action.payload.data);
    yield put(actions.allCategories());
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __hideCategory(action) {
  try {
    yield hideCategory(action.payload.data);
    yield put(actions.allCategories());
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __unhideCategory(action) {
  try {
    yield unhideCategory(action.payload.data);
    yield put(actions.allCategories());
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __createProgressMonitor(action) {
  try {
    const res = yield create_progress_monitor();
    if (res) {
      yield put(actions.set_monitor_id(res.data.progress_monitoring_record.id));
      action.payload.success(res.data.progress_monitoring_record.id);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

function* __GetProgressMonitor(action) {
  try {
    // console.log("called");
    const res = yield get_progress_monitor(action.payload);
    yield put(actions.get_progress_monitor_complete(res.data));
  } catch (e) {
    // console.log(e);
    // const errorMessage = yield call(ErrorHandler, e);
    // action.payload.error(errorMessage);
  }
}

export function* categories() {
  yield takeLatest(actions.GET_CATEGORIES, __CATEGORIES);
}
export function* single_category() {
  yield takeLatest(actions.GET_SINGLE_CATEGORY, __SINGLECATEGORY);
}

export function* hideCat() {
  yield takeLatest(actions.HIDE_CATEGORY, __hideCategory);
}

export function* unhideCat() {
  yield takeLatest(actions.UNHIDE_CATEGORY, __unhideCategory);
}

export function* deleteCat() {
  yield takeLatest(actions.DELETE_CATEGORY, __deleteCategory);
}

export function* addCat() {
  yield takeLatest(actions.ADD_CATEGORY, __addCategory);
}
export function* editCat() {
  yield takeEvery(actions.EDIT_CATEGORY, __editCategory);
}

export function* addNewAttribute() {
  yield takeLatest(actions.ADD_NEW_ATTRIBUTE, __addNewAttribute);
}

export function* editAttribute() {
  yield takeLatest(actions.EDIT_ATTRIBUTE, __editAttribute);
}

export function* appendAttributeValues() {
  yield takeLatest(actions.APPEND_ATTRIBUTE_VALUES, __appendAttributeValues);
}

export function* createProgressMonitor() {
  yield takeLatest(actions.CREATE_PROGRESS_MONITOR, __createProgressMonitor);
}

export function* getProgressMonitor() {
  yield takeEvery(actions.GET_PROGRESS_MONITOR, __GetProgressMonitor);
}
